module.exports = __webpack_public_path__ + "img/dilaudid.e4ee6f1c.png";